import Fifo from 'localstorage-fifo';

const session = new Fifo({ namespace: 'shared-session' });
session.save();

export default session;
